<div class="dialog-backdrop" *ngIf="isVisible" (click)="onBackdropClick($event)" (keydown.escape)="close()">
    <dialog class="webhook-test-dialog" [open]="isVisible" (click)="$event.stopPropagation()"
        (keydown)="onKeyDown($event)" aria-modal="true">
        <div class="dialog-content">
            <div class="dialog-header">
                <div class="dialog-header-row">
                    <h2 class="dialog-title">Test {{ eventType }} Webhook</h2>
                    <div class="response-dropdown" #responseDropdown>
                        <button type="button" class="response-dropdown-toggle" (click)="toggleResponseDropdown()">
                            <span>{{ selectedResponseType }}</span>
                            <svg class="response-dropdown-chevron" [class.open]="isResponseDropdownOpen"
                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <polyline points="6 9 12 15 18 9"></polyline>
                            </svg>
                        </button>
                        <div class="response-dropdown-menu" *ngIf="isResponseDropdownOpen">
                            <button type="button" *ngFor="let option of responseTypeOptions"
                                class="response-dropdown-item" [class.selected]="option === selectedResponseType"
                                (click)="selectResponseType(option)">
                                {{ option }}
                            </button>
                        </div>
                    </div>
                </div>
                
            </div>
            <div class="curl-section">
                <div class="line-numbers" #lineNumbers>
                    <div class="line-number" *ngFor="let line of lineNumbersArray">{{ line }}</div>
                </div>
                <div class="editor-content" #editorContent>
                    <div class="curl-highlight" #highlight [innerHTML]="highlightedContent"></div>
                    <textarea class="curl-input" [(ngModel)]="curlCommand" (ngModelChange)="onCurlCommandChange()"
                        (scroll)="onTextareaScroll($event)" #curlTextarea rows="25" readonly
                        placeholder="Enter curl command here..." spellcheck="false" wrap="off"></textarea>
                </div>
            </div>
        </div>
        <div class="actions-separator"></div>
        <div class="dialog-actions">
            <div class="actions-buttons">
                <button type="button" class="btn-primary" [disabled]="!canSend"
                    (click)="sendTestNotification()">
                    {{ isExecuting ? 'Sending...' : 'Send Test Notification' }}
                </button>
                <button type="button" class="btn-secondary" (click)="close()">Close</button>
            </div>
        </div>
    </dialog>
</div>